import { useQuery } from '@tanstack/react-query';
import { OrganizationsService } from '../services/organizations.service';
import { OrganizationProfile } from '@shared/types/organization';

interface UseOrganizationProfileOptions {
  staleTime?: number;
  refetchOnWindowFocus?: boolean;
  refetchOnMount?: boolean;
}

export const useOrganizationProfile = (
  organizationId?: string,
  options: UseOrganizationProfileOptions = {}
) => {
  const {
    staleTime = 0,
    refetchOnWindowFocus = false,
    refetchOnMount = true,
  } = options;

  const {
    data: profile,
    isLoading,
    error,
    refetch,
  } = useQuery<OrganizationProfile>({
    queryKey: ['organization', organizationId],
    queryFn: () => {
      if (!organizationId) {
        throw new Error('Organization ID is required');
      }
      return OrganizationsService.getOrganizationById(organizationId);
    },
    enabled: !!organizationId,
    staleTime,
    refetchOnWindowFocus,
    refetchOnMount,
  });

  return {
    profile,
    isLoading,
    error,
    refetch,
  };
};
